import Item from "antd/es/list/Item";
import { routeabsheader, routedetails, totalabs } from "./mainabstract";
import { formatDate } from "@progress/kendo-intl";

interface IRouteTotalAbstract {
  totalabstract: totalabs;
}
export const IndentTotalAbstract = (props: IRouteTotalAbstract) => {
  const { totalabstract } = props;
  console.log(totalabstract?.totaldetails);
  return (
    <>
      <div>
        <table
          style={{
            width: "100%",
            borderRadius: "10px",
            marginBottom: "10px",
            borderColor: "#E5E4E2",
            backgroundColor:"#E5E4E2"
          }}
          border={0}
          cellPadding={15}
          cellSpacing={15}
        >
          <tr>
            <th>Milk:</th><td>{totalabstract?.totaldetails?.[0]?.milk}</td>
            <th>Fermented Milk:</th><td>{totalabstract?.totaldetails?.[0]?.fermented}</td>
            <th>Order Date:</th><td>{formatDate(new Date(totalabstract?.totaldetails?.[0]?.orderdate), "dd-MM-yyyy")}</td>
            <th>Ordered Customer:</th><td>{totalabstract?.totaldetails?.[0]?.orderedcustomer}</td>
            <th>Ordered Routes:</th><td>{totalabstract?.totaldetails?.[0]?.orderedroutes}</td>
            <th>Shift:</th><td>{totalabstract?.totaldetails?.[0]?.shift}</td>
          </tr>
        </table>
      </div>
      <div>
        <table
          style={{
            width: "100%",
            borderRadius: "5px",
            marginBottom: "10px",
            borderColor: "#E5E4E2",
          }}
          border={1}
          cellPadding={15}
          cellSpacing={15}
        >
          <tr
            style={{ border: "1px solid #E5E4E2", backgroundColor: "#E5E4E2" }}
          >
            <th>{totalabstract?.totalabstractheader[0]?.col1}</th>
            <th>{totalabstract?.totalabstractheader[0]?.col2}</th>
            <th>{totalabstract?.totalabstractheader[0]?.col3}</th>
            <th>{totalabstract?.totalabstractheader[0]?.col4}</th>
            <th>{totalabstract?.totalabstractheader[0]?.col5}</th>
            <th>{totalabstract?.totalabstractheader[0]?.col6}</th>
            <th>{totalabstract?.totalabstractheader[0]?.col7}</th>
            <th>{totalabstract?.totalabstractheader[0]?.col8}</th>
            <th>{totalabstract?.totalabstractheader[0]?.col9}</th>
            <th style={{ float: "right" }}>
              {totalabstract?.totalabstractheader[0]?.col10}
            </th>
            <th style={{ float: "right" }}>
              {totalabstract?.totalabstractheader[0]?.col11}
            </th>
          </tr>
          {totalabstract?.totalabstract?.map((item) => {
            return (
              <>
                <tr style={{ borderRadius: "5px" }}>
                  <td>{item?.col1}</td>
                  <td>{item?.col2}</td>
                  <td>{item?.col3}</td>
                  <td>{item?.col4}</td>
                  <td>{item?.col5}</td>
                  <td>{item?.col6}</td>
                  <td>{item?.col7}</td>
                  <td>{item?.col8}</td>
                  <td>{item?.col9}</td>
                  <td style={{ float: "right" }}>
                    {item?.col10 > 0 ? item?.col10?.toFixed(2) : 0}
                  </td>
                </tr>
              </>
            );
          })}
        </table>
      </div>
    </>
  );
};
